export default __webpack_public_path__ + "static/media/failed.ec772815.svg";